import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_inventory_measurement_units_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, DimensionUomId?: number, Height?: number, Length?: number, Name?: string, ShippingWeight?: number, ShortName?: string, Weight?: number, WeightUomId?: number, Width?: number, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_inventory_measurement_units_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, DimensionUomId?: number, Height?: number, Length?: number, Name?: string, ShippingWeight?: number, ShortName?: string, Weight?: number, WeightUomId?: number, Width?: number, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Materials/datasources/ds_inventory_measurement_units_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, DimensionUomId?: number, Height?: number, Length?: number, Name?: string, ShippingWeight?: number, ShortName?: string, Weight?: number, WeightUomId?: number, Width?: number, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_inventory_measurement_units_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
